import { MessageCircle, MapPin, Clock } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { LeadForm } from "../components/LeadForm";
import { BRAND_ICONS } from "../components/BrandIcons";
import { COMPANY, SOCIALS } from "../lib/content";

export default function Contact() {
    return (
        <div className="relative overflow-hidden" data-testid="contact-page">
            <div className="glow-orb right-[5%] top-[-5%] h-[380px] w-[380px] bg-cyan-500/12" />
            <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
                <Reveal className="text-center">
                    <Eyebrow>Contact Us</Eyebrow>
                    <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-testid="contact-heading">
                        Let's build your <span className="cyan-gradient-text">AI team</span>
                    </h1>
                    <p className="mx-auto mt-4 max-w-xl text-slate-400">
                        Tell us about your business — an AI specialist will reach out within 24 hours.
                    </p>
                </Reveal>

                <div className="mt-14 grid gap-8 lg:grid-cols-5">
                    <Reveal className="lg:col-span-3">
                        <div className="glow-card rounded-3xl p-7 sm:p-9">
                            <LeadForm type="contact" testid="contact" />
                        </div>
                    </Reveal>
                    <Reveal delay={0.15} className="lg:col-span-2">
                        <div className="flex h-full flex-col gap-5">
                            <a
                                href={COMPANY.whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-whatsapp-card"
                                className="glow-card group flex items-center gap-4 rounded-2xl p-6"
                            >
                                <div className="rounded-xl bg-emerald-500/15 p-3.5 text-emerald-400 transition-transform group-hover:scale-110">
                                    <MessageCircle className="h-6 w-6" />
                                </div>
                                <div>
                                    <p className="font-display font-bold text-white">WhatsApp Us</p>
                                    <p className="text-sm text-slate-400 notranslate">{COMPANY.phoneDisplay}</p>
                                </div>
                            </a>
                            <a
                                href={COMPANY.maps}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-maps-card"
                                className="glow-card group flex items-center gap-4 rounded-2xl p-6"
                            >
                                <div className="rounded-xl bg-blue-500/15 p-3.5 text-blue-400 transition-transform group-hover:scale-110">
                                    <MapPin className="h-6 w-6" />
                                </div>
                                <div>
                                    <p className="font-display font-bold text-white">Google Business Profile</p>
                                    <p className="text-sm text-slate-400">Find us on Google Maps</p>
                                </div>
                            </a>
                            <div className="glow-card flex items-center gap-4 rounded-2xl p-6" data-testid="contact-hours-card">
                                <div className="rounded-xl bg-cyan-500/15 p-3.5 text-cyan-400">
                                    <Clock className="h-6 w-6" />
                                </div>
                                <div>
                                    <p className="font-display font-bold text-white">AI Never Sleeps</p>
                                    <p className="text-sm text-slate-400">Our AI employees respond 24/7 — humans reply within 24h</p>
                                </div>
                            </div>
                            <div className="glow-card rounded-2xl p-6" data-testid="contact-socials-card">
                                <p className="font-display font-bold text-white">Follow the journey</p>
                                <div className="mt-4 flex gap-2.5">
                                    {SOCIALS.map((s) => {
                                        const Icon = BRAND_ICONS[s.icon];
                                        return (
                                            <a
                                                key={s.name}
                                                href={s.href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-label={s.name}
                                                data-testid={`contact-social-${s.icon}`}
                                                className="rounded-full border border-white/10 bg-white/5 p-2.5 text-slate-400 transition-colors hover:border-cyan-500/50 hover:text-cyan-300"
                                            >
                                                <Icon className="h-4 w-4" />
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
